import { get, post } from './http';

export type AuditActionType =
  | 'create'
  | 'update'
  | 'delete'
  | 'publish'
  | 'login'
  | 'export'
  | 'points_earn'
  | 'checkin'
  | 'like'
  | 'share';

export type AuditActionInput = AuditActionType | 'edit';
export type AuditStatus = 'success' | 'failed';
export type AuditScope = 'all' | 'mine';

export interface AuditModuleOption {
  key: string;
  label: string;
}

export interface AuditOperatorOption {
  userId: number | null;
  name: string;
}

export interface AuditLogItem {
  id: number;
  actionType: AuditActionType;
  moduleKey: string;
  moduleLabel: string;
  targetText: string;
  detailText: string | null;
  operatorUserId: number | null;
  operatorName: string;
  status: AuditStatus;
  pointsAmount: number | null;
  ipAddress: string | null;
  userAgent: string | null;
  createdAt: string | null;
}

export interface AuditLogListResult {
  scope: AuditScope;
  total: number;
  page: number;
  pageSize: number;
  list: AuditLogItem[];
  modules: AuditModuleOption[];
  operators: AuditOperatorOption[];
}

export interface AuditLogStats {
  scope: AuditScope;
  total: number;
  today: number;
  creates: number;
  updates: number;
  deletes: number;
  publishes: number;
  checkins: number;
  likes: number;
  shares: number;
  pointsEarnActions: number;
  pointsTotal: number;
}

export interface ListAuditLogsParams {
  scope?: AuditScope;
  keyword?: string;
  moduleKey?: string;
  actionType?: AuditActionType | 'all';
  status?: AuditStatus | 'all';
  operatorUserId?: number;
  page?: number;
  pageSize?: number;
}

export interface CreateAuditLogPayload {
  action: AuditActionInput;
  module: string;
  target: string;
  detail?: string;
  status?: AuditStatus;
  pointsAmount?: number;
}

export function listAuditLogs(params?: ListAuditLogsParams) {
  return get<AuditLogListResult>('/admin/audit-logs', params ? { params } : undefined);
}

export function getAuditLogStats(params?: ListAuditLogsParams) {
  return get<AuditLogStats>('/admin/audit-logs/stats', params ? { params } : undefined);
}

export function createAuditLog(payload: CreateAuditLogPayload) {
  return post<{ id: number }>('/admin/audit-logs', payload);
}
